import { DeliveryMethod } from "../../../state/types"
import { DeliveryOrderList } from "../delivery-order-list/deliveryOrderList"

export const ShipmentOrderList = () => {
    return <DeliveryOrderList method={DeliveryMethod.SHIPMENT} />
}
